module.exports = __webpack_public_path__ + "static/media/CreateBrand.acf9a880.svg";